const component = "section-details-readonly-content";

export const sectionDetailsReadonlyContent = {
  component,
  sectionArea: `${component}/section-area`,
  sectionCategoryName: `${component}/section-category-name`,
  sectionParentName: `${component}/section-parent-name`,
};
